import { PageHead } from '../../ui'
import LeadManager from '../../features/tracking/LeadManager'
import SalesSourceSummary from '../../features/tracking/SalesSourceSummary'
import { useCompany } from '../../lib/company'

export default function Sales() {
  const company = useCompany()
  return (
    <div className="stack" style={{ gap: 20 }}>
      <PageHead title="Clientes e vendas" sub="Atenda contatos no WhatsApp e registre vendas realizadas e recompras por cliente." />
      <SalesSourceSummary companyId={company.id} />
      <LeadManager />
    </div>
  )
}
